import { isEmpty } from 'lodash';
import L from 'leaflet';
import turf from '@turf/turf';

import { getDTMBbox } from '../../api/Projects/project-operations';

/**
 * Draws the DTM bounding box on the leaflet map.
 *
 * @param {object} arg - The object argument.
 * @param {object} arg.leafletMap - The leaflet map object.
 * @param {object} arg.project - The project object.
 * @param {?object} arg.DTMBBoxLayer - The geoJSON layer where the DTM bounding box is painted.
 * @param {boolean} [arg.isUpdate=false] - Flag to determine if we are doing an update.
 * @returns {object} The leaflet layer where the DTM bounding box is painted.
 */
const drawDTMBBox = ({ DTMBBoxLayer, project, leafletMap, isUpdate = false }) => {
  let newDTMBBox = '';
  if (!isUpdate) {
    newDTMBBox = L.geoJSON(null, { color: '#5cb85c', weight: 4, fill: false }).addTo(leafletMap);
  } else {
    newDTMBBox = DTMBBoxLayer;
    newDTMBBox.clearLayers();
  }

  const projectDTMBbox = getDTMBbox(project);

  if (!isEmpty(projectDTMBbox)) {
    const bboxGEOJSON = turf.polygon([
      [
        [projectDTMBbox[0], projectDTMBbox[1]],
        [projectDTMBbox[2], projectDTMBbox[1]],
        [projectDTMBbox[2], projectDTMBbox[3]],
        [projectDTMBbox[0], projectDTMBbox[3]],
        [projectDTMBbox[0], projectDTMBbox[1]]
      ]
    ]);
    newDTMBBox.addData(bboxGEOJSON);
  }
  return newDTMBBox;
};

export default drawDTMBBox;
